// extracted by mini-css-extract-plugin
module.exports = {"SwitchWrapper":"Switch_SwitchWrapper__2bgyw","Switch":"Switch_Switch__1pKl0"};